module.exports = __webpack_public_path__ + "img/reward.0f367e74.svg";